// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"6402394a","237":"6402394a","336":"1ec73e3f","507":"6402394a","737":"6402394a","743":"6402394a","971":"6402394a"}[chunkId] + ".chunk.css";
};